











import { Component, Vue } from 'vue-property-decorator';
@Component(
{
  components: {

  },

  data() {

    return {
    }},
  mounted(){
  
  }

        
    
}

)
export default class techos_report extends Vue {}
//techos_report


